import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import VitalAlertsTable from './eventLogsTable';
import constant from '../../constant';

const VitalAlertsContent = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { hospId, patientId } = useParams();

  const fetchAlerts = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No authentication token found');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${constant.REACT_APP_API_URL}/hospital/${hospId}/patient/${patientId}/vital-alerts`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const result = await response.json();
      if (response.ok) {
        setAlerts(result || []);
      } else {
        setError(result.message || 'Failed to fetch vital alerts');
      }
    } catch (err) {
      setError('Network error while fetching alerts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlerts();
  }, [hospId]);

  const handleStatusUpdate = async (alertId, newStatus) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(
        `${constant.REACT_APP_API_URL}/hospital/${hospId}/patient/${patientId}/vital-alerts/${alertId}`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ alert_status: newStatus }),
        }
      );

      if (response.ok) {
        setAlerts(prev =>
          prev.map(alert =>
            alert.alert_id === alertId ? { ...alert, alert_status: newStatus } : alert
          )
        );
      }
    } catch (err) {
      console.error('Failed to update alert status');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10 text-red-600">
        {error}
      </div>
    );
  }

  return (
    <div className="bg-white px-6 pt-16 md:pt-0">
      <div className="">

        <VitalAlertsTable alerts={alerts} onStatusUpdate={handleStatusUpdate} />
      </div>
    </div>
  );
};

export default VitalAlertsContent;